module.exports = __webpack_public_path__ + "img/SK30847737.6805e424.png";